import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RegistrationComponent } from '../../modals/registration/registration.component';
import { TranslateService } from '@ngx-translate/core';
import { StmgService } from '../../services/state_Management/stmg.service';
import { StorageServicesService } from '../../services/storage_services/storage-services.service';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../components/alert/alert.component';
import { LoginComponent } from "../../modals/login/login.component";
import { mySlips_pObj } from '../../services/payload/mySlips_pobj';
import { UserServiceService } from '../../services/user_service/user-service.service';
import { CommonServiceService } from '../../services/common_service/common-service.service';
import { Router } from '@angular/router';
import { PlayerModalComponent } from '../alert/player-modal/player-modal.component';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
})
export class HeaderBarComponent implements OnInit {
  currentVideoLinks: any[];
  timerSubscription: Subscription;
  videoPlayer: HTMLIonModalElement;
  showHomeElements:boolean;

  constructor(
    public modalController: ModalController,
    public translate: TranslateService,
    private stmgService: StmgService,
    private storageService: StorageServicesService,
    public alertController: AlertController,
    private userService: UserServiceService,
    private commonservice: CommonServiceService,
    private router: Router,
  ) {

    // Show Slider, Cricket and Inplay images on the initial load.
    const showHomeElements = this.storageService.getLocal("showHomeElements");

    if(showHomeElements == null || showHomeElements == "true"){
      this.showHomeElements = true;
    }else{
      this.showHomeElements = false;
    }
  }

  is_logged = false;
  is_registered = false;
  mySlipsParams = new mySlips_pObj();
  videoUrl: any;
  videoToken: any;
  showVideo: boolean;
  selectedLanguage: any;

  ngOnInit() {
    this.selectedLanguage= JSON.parse( this.storageService.getLocal("language"))
    this.stmgService.is_logged_status.subscribe(message => {
      this.is_logged = message
      if (this.storageService.getLocal("accountNo")) {
        this.is_registered = true;
      }
    });

    //this.stmgService.language_status.subscribe(message => this.selectedLanguage = message);

    //this.getvideoUrlFromMySlips()
    this.stmgService.setHeaderBar(this);

    this.stmgService.showHomeElements$.subscribe((value) => {
      this.showHomeElements = value;
    });
  }

  changeLang(lang) {
    this.storageService.localStore("language", lang);
    this.stmgService.updatelanguage(lang);
    this.selectedLanguage = lang
  }

  // getvideoUrlFromMySlips() {
  //   if (this.is_logged) {
  //     this.mySlipsParams.token = this.commonservice.getToken();
  //     this.mySlipsParams.accountNumber = this.commonservice.getaccountNo();
  //     this.mySlipsParams.lastSlipId = 0;

  //     this.userService.getUserBets(this.mySlipsParams).subscribe(data => {
  //       this.setData(data);
  //       console.log(data);

  //       this.currentVideoLinks = [];
  //       data.forEach(slips => {
  //         slips.bets.forEach(bets => {
  //           if(bets.betSelections[0].eventSelection['showVideo']==true){
  //             this.currentVideoLinks.push(bets.betSelections[0].eventSelection)
  //             this.showVideo=true;
  //           }
  //         });
  //       });
  //       console.log(this.currentVideoLinks);
  //     });
  //   }
  // }

  setData(data) {
    //console.log("my slip data set in header", data)
    this.videoUrl = data[0].bets[0].betSelections[0].eventSelection.videoURL;
    this.videoToken = data[0].bets[0].betSelections[0].eventSelection.videoToken;
    if (data[0].bets[0].betSelections[0].eventSelection.showVideo == true) {
      this.showVideo == true;
    }
    else {
      this.showVideo == false;
    }
  }

  async newAccount() {
    const modal = await this.modalController.create({
      component: RegistrationComponent,
      cssClass: 'customPopup'
    });
    return await modal.present();
  }

  click_logout() {
    this.logoutAlert();
  }

  async logoutAlert() {
    let alertHeader: string;
    let alertmsg: string;
    this.translate.get('ALERTS.LOGOUT.HEADER').subscribe((res: string) => {
      alertHeader = res;
    });
    this.translate.get('ALERTS.LOGOUT.MSG').subscribe((res: string) => {
      alertmsg = res;
    });
    let yes: string;
    let no: string;
    this.translate.get('COMMON.YES').subscribe((res: string) => {
      yes = res;
    });
    this.translate.get('COMMON.NO').subscribe((res: string) => {
      no = res;
    });
    const deleteAlert = await this.alertController.create({
      header: alertHeader,
      message: alertmsg,
      buttons: [
        {
          text: no,
        },
        {
          text: yes,
          handler: ()=>{
            this.stmgService.updateLoginStatus(false);
            this.router.navigate(['home']);

            let alertTitle:string;
            let alertDesc:string;
            this.translate.get('ALERTS.LOGOUT.TITLE').subscribe((res: string) => {
              alertTitle=res;
            });
            this.translate.get('ALERTS.LOGOUT.DESC').subscribe((res: string) => {
              alertDesc=res;
            });
            let alert = new AlertComponent(this.alertController);
            alert.loginSuccessAlert("", alertTitle, alertDesc);
            
          }
        }
      ]
    });
    await deleteAlert.present();
  }

  async launchLogin() {
    const modal = await this.modalController.create({
      component: LoginComponent,
      cssClass: "customPopup",
    });
    return await modal.present();
  }

  async watchLiveVideos() {
    //this.getvideoUrlFromMySlips()
    if (this.is_logged == true) {
      this.mySlipsParams.token = this.commonservice.getToken();
      this.mySlipsParams.accountNumber = this.commonservice.getaccountNo();
      this.mySlipsParams.lastSlipId = 0;

      this.userService.getUserBets(this.mySlipsParams).subscribe(async data => {
        this.setData(data);
        //console.log(data);

        this.currentVideoLinks = [];
        data.forEach(slips => {
          slips.bets.forEach(bets => {
            if (bets.betSelections[0].eventSelection['showVideo'] == true) {
              this.currentVideoLinks.push(bets.betSelections[0].eventSelection)
              this.showVideo = true;
            }
          });
        });
        //console.log(this.currentVideoLinks);

        //console.log(this.showVideo);
        if (this.showVideo == true) {
          const modal = await this.modalController.create({
            component: PlayerModalComponent,
            componentProps: { videoUrl: this.currentVideoLinks[0].videoURL },
            cssClass: 'customPopup'
          });
          this.videoPlayer=modal;
          this.videoAutoClose(this.currentVideoLinks[0].eventId);

          modal.onDidDismiss().then((data) => {
            this.timerSubscription.unsubscribe();
            this.showVideo = false;
          });

          return await modal.present();
        }
        else {
          let alertTitle:string;
          let alertDesc:string;
          this.translate.get('ALERTS.NO_VIDEO.TITLE').subscribe((res: string) => {
            alertTitle=res;
          });
          this.translate.get('ALERTS.NO_VIDEO.DESC').subscribe((res: string) => {
            alertDesc=res;
          });
          let alert = new AlertComponent(this.alertController);
          alert.loginSuccessAlert("", alertTitle, alertDesc);
        }
      });
    }
    else {
    let alertTitle:string;
    let alertDesc:string;
    this.translate.get('ALERTS.LOGTO_VIDEO.TITLE').subscribe((res: string) => {
      alertTitle=res;
    });
    this.translate.get('ALERTS.LOGTO_VIDEO.DESC').subscribe((res: string) => {
      alertDesc=res;
    });
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle,alertDesc);
    }
  }


  videoAutoClose(eventId){
    //run every 40 seconds
    this.timerSubscription = interval(4000).subscribe((x => {
      this.userService.getVideoUrl({eventId:eventId,token:this.mySlipsParams.token}).subscribe(data=>{
        //console.log(data);
        if(data.status=="true"){
          this.videoPlayer.dismiss();
        }
      })
    }));
  }

  @Output() showHomeElementsChange = new EventEmitter<boolean>();

  redirectToHome(){
    this.router.navigate(["/home/nextten"]);
    this.showHomeElements = true;
    this.storageService.localStore("showHomeElements",true);
    this.showHomeElementsChange.emit(this.showHomeElements);
    this.stmgService.setShowHomeElements(true);

    // FOR VIRTUAL SECTION INSIDE CHANGE
    this.stmgService.setInVirtualSection(false);
  }

  updateShowHomeElements(showHomeElements: boolean) {
    this.showHomeElements = showHomeElements;
    this.showHomeElementsChange.emit(this.showHomeElements);
  }



}
